/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { UserId } from "../../commons/types/UserId";
export const OnboardingCreate = core.serialization.object({
    userId: UserId,
});
